module.exports = __webpack_public_path__ + "images/category_lp/hobby/bg-star_1cd94c21b044da78be10c5a6227ae82f.png";